// SPDX-FileCopyrightText: 2025 Slant Tech LLC
// SPDX-License-Identifier: GPL-3.0-or-later

import api from '../api';

function LoginScreen({ onLogin, authEnabled = true }) {
  const handleLogin = () => {
    // Redirect to GitLab OAuth login
    window.location.href = api.getLoginUrl();
  };

  return (
    <div className="min-h-screen bg-st-primary flex items-center justify-center">
      <div className="bg-st-secondary border-2 border-st-border p-8 max-w-md w-full mx-4 text-center">
        {/* Logo */}
        <div className="mb-6">
          <svg viewBox="0 0 100 100" className="w-20 h-20 mx-auto">
            <rect x="5" y="5" width="90" height="90" fill="rgb(var(--st-bg-primary))" stroke="#FF6600" strokeWidth="3"/>
            <g fill="#FF6600">
              <rect x="20" y="35" width="25" height="3"/>
              <rect x="55" y="35" width="25" height="3"/>
              <rect x="20" y="62" width="25" height="3"/>
              <rect x="55" y="62" width="25" height="3"/>
              <rect x="48" y="20" width="3" height="20"/>
              <rect x="48" y="60" width="3" height="20"/>
            </g>
            <rect x="35" y="40" width="30" height="20" fill="#1A1614"/>
            <g fill="#FF6600" opacity="0.6">
              <rect x="35" y="43" width="4" height="3"/>
              <rect x="35" y="49" width="4" height="3"/>
              <rect x="35" y="55" width="4" height="3"/>
              <rect x="61" y="43" width="4" height="3"/>
              <rect x="61" y="49" width="4" height="3"/>
              <rect x="61" y="55" width="4" height="3"/>
            </g>
          </svg>
        </div>

        <h1 className="text-2xl font-display font-bold mb-2">KiCad Review App</h1>
        <p className="text-st-muted mb-8 font-body">
          Sign in with GitLab to review KiCad designs
        </p>

        {authEnabled ? (
          <>
            <button
              onClick={handleLogin}
              className="w-full btn btn-lg bg-st-accent hover:bg-st-accent-hover text-white py-3 text-lg flex items-center justify-center gap-3"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 01-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 014.82 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0118.6 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.51L23 13.45a.84.84 0 01-.35.94z"/>
              </svg>
              Sign in with GitLab
            </button>

            <p className="text-xs text-st-muted mt-6 font-body">
              You'll be redirected to GitLab to authorize this application.
              <br />
              Your GitLab username will be used for comments.
            </p>
          </>
        ) : (
          <div className="text-st-warning">
            <p className="font-display font-semibold">Authentication is required but not configured.</p>
            <p className="text-sm mt-2 font-body">Please contact the administrator.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginScreen;
